import _ from 'lodash';

import getDatabase from 'Common/DB';
import {
  onSessionCreated,
  clearCurrentSession,
} from 'PointOfSale/modules/servingOptions/state/actions';
import { loading, success, error } from 'State/actions';
import { AlternateProvisionTypeEnum } from 'Common/Constants/Enumeration/AlternateProvisionTypeEnum';
import * as CommonStateSelectors from 'State/selectors';
import * as POSSelectors from 'PointOfSale/selectors';
import * as types from './types';
import {
  AUTO_SERVE_OPTIONS,
  POS_ROUTES,
} from 'PointOfSale/modules/common/constants';

export const setSiteAndDate = (data, currentUrl, history) => (
  dispatch,
  getState
) => {
  const state = getState();

  const {
    servingSites,
    cepType,
    isPopupCallFromHeader,
  } = state.PointOfSaleState.dateAndSiteDetails;
  const selectedSite = _.filter(
    servingSites,
    site => site.Id === data.selectedSite
  )[0];
  data.selectedSite = selectedSite;
  if (currentUrl === POS_ROUTES.SERVE_OPTIONS && !isPopupCallFromHeader) {
    const currentSession = state.PointOfSaleState.servingOptions.currentSession;
    const { type, autoServe } = currentSession;

    const isCEPSite =
      POSSelectors.getSelectedSiteAlternateProvisionTypeId(state) ===
      AlternateProvisionTypeEnum.CEP;

    const isCEPServe =
      isCEPSite && autoServe && cepType.Id === AUTO_SERVE_OPTIONS.MealCounter;

    if (isCEPServe) {
      currentSession.queueType = AUTO_SERVE_OPTIONS.MealCounter;
    }
    const servingOptions = {
      Queue: isCEPServe
        ? POS_ROUTES.MEAL_COUNTER
        : autoServe
        ? POS_ROUTES.QUEUE
        : POS_ROUTES.QUEUE_NEW,
      Group: POS_ROUTES.GROUP,
      Teacher: POS_ROUTES.TEACHER,
    };

    const nextRoute = servingOptions[type];
    dispatch(onSessionCreated(currentSession));
    history.push(nextRoute);

    dispatch(clearCurrentSession());
  }
  dispatch({
    type: types.SET_SITE_DATA,
    payload: data,
  });
};

export const getServingSites = () => async (dispatch, getState, MPWWebAPI) => {
  const state = getState();
  dispatch(loading(types.GET_SERVING_SITES_FETCHING, true));
  const isOnline =
    CommonStateSelectors.getOnline(state) &&
    CommonStateSelectors.getServerUp(state);
  try {
    if (isOnline) {
      const response = await MPWWebAPI.getGeneric('Serving/GetServingSites');
      const sites = response.data.Data;
      dispatch(success(types.GET_SERVING_SITES_FETCH, sites));
    } else {
      const databaseName = CommonStateSelectors.getDatabaseName(state);
      const DB = await getDatabase(databaseName);
      const sites = await DB.ServingSites.toArray();
      dispatch(success(types.GET_SERVING_SITES_FETCH, sites));
    }
  } catch (err) {
    dispatch(error(types.GET_SERVING_SITES_FETCH_ERROR, err));
  }
  dispatch(loading(types.GET_SERVING_SITES_FETCHING, false));
};

export const setSiteDatePopupOpen = (
  isPopupCallFromHeader = false,
  isSetDateAndSitePopupOpen = true
) => ({
  type: types.OPEN_SETUP_POP,
  payload: { isSetDateAndSitePopupOpen, isPopupCallFromHeader },
});

export const setSiteDatePopupClose = (
  isPopupCallFromHeader = false,
  isSetDateAndSitePopupOpen = false
) => ({
  type: types.OPEN_SETUP_POP,
  payload: { isSetDateAndSitePopupOpen, isPopupCallFromHeader },
});

export const setCepType = cepType => ({
  type: types.SET_CEP_TYPE,
  payload: cepType,
});

export const setSiteDetails = ({ siteDate, selectedSite }) => dispatch => ({
  type: types.SET_SITE_DATA,
  payload: {
    siteDate,
    selectedSite,
  },
});



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/setDateAndSite/state/action.js